import { render } from "./iframe.vue?vue&type=template&id=0d6a624a"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"

import "./iframe.vue?vue&type=style&index=0&id=0d6a624a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__